import { memo } from "react";
import classNames from "classnames";

import customTwMerge from "@/utils/customTwMerge";

interface TickProps {
    className?: string;
    label?: string;
    disabled?: boolean;
}

const Tick = ({ className, label = "✓", disabled }: TickProps) => (
    <div
        className={customTwMerge(
            "relative h-6 w-6 rounded-lg",
            classNames({
                "bg-zing-lime-200 text-black female:bg-zing-warm-tangerine-500 female:text-white":
                    !disabled,
                "bg-white bg-opacity-[0.24] text-white text-opacity-60": disabled,
            }),
            className
        )}
    >
        <span className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 transform">
            {label}
        </span>
    </div>
);

export default memo(Tick);
